import { updateTicketDetails } from "../../../services/merpservices";
import { buildAPIRequestParams } from "../../../utils/Misc/buildAPIParams";

// --- Close Ticket Function ---
export const handleTicketClosure = async ({
  ticketId,
  ticketTypeid,
  employeeDetails,
  tktComments,
  tickets_clousers_id,
  tickets_clousers_id1 = 2378,
  tickets_clousers_id2,
  showAlert = false
}) => {
  try {
    const closingTicketParams = buildAPIRequestParams({
      updatedbyid: employeeDetails?.empid,
      ticket_id: ticketId,
      ticket_type_id: ticketTypeid,
      group_id: 15,
      Custtype_name: "CATALOG",
      tickets_clousers_id: tickets_clousers_id,
      tickets_clousers_id1: tickets_clousers_id1,
      tickets_clousers_id2: tickets_clousers_id2,
      isTeleMVertical: 0,
      ticketflag: "closeticket",
      empid: employeeDetails?.empid,
      AK: employeeDetails?.ak,
      comments: tktComments,
      modid: 9696,
    });

    const response = await updateTicketDetails(closingTicketParams);

    if (response?.data?.status === 200) {
      // Show alert only when flag is true
      if (showAlert){
        alert("STS OCR has been updated..!");
      }
      return { success: true };
    } else {
      console.error("Ticket closure failed:", response);
      return { success: false, message: "Ticket closure failed", response };
    }
  } catch (error) {
    console.error("Error during ticket closure:", error);
    return { success: false, message: error.message };
  }
};